"use client";

import { createBrowserClient } from "@supabase/ssr";
import type { SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnon = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

let _supabase: SupabaseClient | null = null;

export function getSupabaseBrowser(): SupabaseClient {
  if (_supabase) return _supabase;

  // Usa createBrowserClient da @supabase/ssr invece di createClient
  // così la sessione viene salvata nei cookie e il server può leggerla
  _supabase = createBrowserClient(supabaseUrl, supabaseAnon);

  console.log("🔐 Supabase client creato con URL:", supabaseUrl);

  if (typeof window !== "undefined") {
    (window as any).sb = _supabase;
  }

  return _supabase;
}

export const supabase = getSupabaseBrowser();